import { styled } from 'styled-components'

export const MainWrapper = styled.div`
    width: 100%;
    padding: ${props => `0 ${props.theme.padding}px`};
    display: flex;
    flex-direction: column;
`

export const TitleWrapper = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: ${props => `${props.theme.marginXS}px`};
`
